import { ViewTrialsButton } from '@components/app/Button/ViewTrials'
import { TableOfContentsItem } from '@components/app/ListingPage/TableOfContents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import type { InViewHookResponse } from 'react-intersection-observer'

export type TreatmentPageSection =
  | 'about'
  | 'overview'
  | 'efficacy'
  | 'sideEffects'
  | 'approvedUses'
  | 'dosages'
  | 'cost'
  | 'demographics'
  | 'warnings'
  | 'novelUses'
  | 'relatedTrials'
  | 'reviews'

type TreatmentPageRefs = {
  [sectionId in TreatmentPageSection]: InViewHookResponse
}

export const TreatmentPageTableOfContents = ({
  sectionRefs,
}: {
  sectionRefs: TreatmentPageRefs
}) => {
  return (
    <nav className='sticky top-24 mr-8 hidden rounded-md border border-neutral300 p-6 lg:block'>
      <TableOfContentsItem
        hook={sectionRefs.about}
        sectionId='about'
        text='About'
      />
      <TableOfContentsItem
        hook={sectionRefs.approvedUses}
        sectionId='approvedUses'
        text='FDA Approvals'
      />
      <TableOfContentsItem
        hook={sectionRefs.efficacy}
        sectionId='efficacy'
        text='Effectiveness'
      />
      <TableOfContentsItem
        hook={sectionRefs.sideEffects}
        sectionId='sideEffects'
        text='Side-Effects'
      />
      <TableOfContentsItem
        hook={sectionRefs.dosages}
        sectionId='dosages'
        text='Dosage'
      />
      <TableOfContentsItem
        hook={sectionRefs.cost}
        sectionId='cost'
        text='Cost'
      />
      <TableOfContentsItem
        hook={sectionRefs.demographics}
        sectionId='demographics'
        text='How It Affects Patients'
      />
      <TableOfContentsItem
        hook={sectionRefs.warnings}
        sectionId='warnings'
        text='Warnings'
      />
      <TableOfContentsItem
        hook={sectionRefs.novelUses}
        sectionId='novelUses'
        text='Novel Uses'
      />
      <TableOfContentsItem
        hook={sectionRefs.reviews}
        sectionId='reviews'
        text='Patient Reviews'
      />
      {sectionRefs.relatedTrials.entry && (
        <ViewTrialsButton source={TrackingSources.TREATMENT_PAGE} />
      )}
    </nav>
  )
}
